import React from 'react';
import { DesignHeader } from './DesignHeader';
import { ContentLayout } from '../ui/ContentLayout';
import { RequiredActions } from './caseStudies/RequiredActions';
export function CaseStudyContent({
  activePage,
  onNavigate,
  onOpenMobileMenu
}: {
  activePage: string;
  onNavigate: (page: string) => void;
  onOpenMobileMenu: () => void;
}) {
  const slug = activePage.replace(/^work\//, '');
  const renderContent = () => {
    switch (slug) {
      case 'required-actions':
      default:
        return <RequiredActions data-id="element-69" />;
    }
  };
  return <div className="flex-1 bg-white text-black flex flex-col min-h-screen" data-id="element-70">
      <DesignHeader onNavigate={onNavigate} onOpenMobileMenu={onOpenMobileMenu} closeTarget="complexity" data-id="element-71" />

      <div className="flex-1 overflow-y-auto" data-id="element-72">
        <ContentLayout data-id="element-73">{renderContent()}</ContentLayout>
      </div>
    </div>;
}